class AssignLeadsToOrgreq {
    constructor() {
        this.fiberHouseIds = []
        this.salesOrgId = ""
    }
}

export default AssignLeadsToOrgreq